import { render, staticRenderFns } from "./PublicChats.vue?vue&type=template&id=5772db68&scoped=true&"
import script from "./PublicChats.vue?vue&type=script&lang=js&"
export * from "./PublicChats.vue?vue&type=script&lang=js&"
import style0 from "./PublicChats.vue?vue&type=style&index=0&id=5772db68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772db68",
  null
  
)

export default component.exports